import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { Lock } from 'lucide-react';

const LOGO_ICON = "/logo.png";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(e => e.msg).join(' ') : 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md rounded-2xl border-border shadow-lg" data-testid="admin-login-card">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="logo-container inline-flex items-center justify-center h-16 w-16 rounded-2xl mx-auto mb-4">
              <img src={LOGO_ICON} alt="Dr. Preet" className="h-12 w-12 object-contain" />
            </div>
            <h1 className="font-heading text-2xl font-medium">Admin Panel</h1>
            <p className="text-sm text-muted-foreground mt-1">Sign in to manage your clinic website</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="admin-email" className="text-sm font-medium">Email</Label>
              <Input id="admin-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required className="h-12 mt-2 rounded-xl" placeholder="admin@drpreetwomensclinic.com" data-testid="admin-email-input" />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-sm font-medium">Password</Label>
              <Input id="admin-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required className="h-12 mt-2 rounded-xl" placeholder="Enter password" data-testid="admin-password-input" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl" data-testid="admin-login-submit">
              {loading ? 'Signing in...' : <><Lock className="w-4 h-4 mr-2" /> Sign In</>}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
